import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import { Carousel } from 'src/ui/common/molecules/carousel';
import styled from 'styled-components';

export const StyledHeading = styled(Typography)`
    text-align: left;
    font-size: 36px;
    line-height: 140%;

    ${media.sm`
        font-size: 48px;
    `}

    ${media.md`
        font-size: 72px;
    `}
`;

export const StyledBannerContainer = styled.div`
    max-width: 2584px;
    margin: -126px auto 0;
    width: 100%;
    position: relative;
`;

export const StyledTitleWrapper = styled.div`
    position: absolute;
    bottom: 170px;
    left: 16px;
    z-index: 1;

    ${media.sm`
        left: 16px;
        bottom: 180px;
    `}

    ${media.md`
        left: 48px;
        bottom: 212px;
    `}

  ${media.lg`
        left: calc((100% - 1440px + 48px + 48px) / 2);
        bottom: 212px;
    `}
`;

export const StyledCarousel = styled(Carousel)``;

export const StyledNextArrowWrapper = styled.div`
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 56px;
    backdrop-filter: blur(4px);
    position: absolute;
    right: 18px;
    bottom: 24px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    z-index: 2;

    & svg {
        position: absolute;
        top: 5px;
        right: 5px;
    }

    ${media.sm`
        bottom: 48px;
        width: 56px;
        height: 56px;
        right: 16px;
        
         & svg {
            position: absolute;
            top: 12px;
            right: 14px;
        }
    `}

    ${media.md`
        bottom: 48px;
        width: 56px;
        height: 56px;
        right: 16px;
        
         & svg {
            position: absolute;
            top: 12px;
            right: 14px;
        }
    `}

  ${media.lg`
        bottom: 48px;
        width: 56px;
        height: 56px;
        right: calc((100% - 1344px) / 2);
        
         & svg {
            position: absolute;
            top: 12px;
            right: 14px;
        }
    `}
`;

export const StyledPrevArrowWrapper = styled.div`
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 56px;
    backdrop-filter: blur(4px);
    position: absolute;
    right: 64px;
    bottom: 24px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    z-index: 2;

    & svg {
        position: absolute;
        top: 5px;
        right: 5px;
    }

    ${media.sm`
        bottom: 48px;
        width: 56px;
        height: 56px;
        right: 90px;
        
        & svg {
            position: absolute;
            top: 12px;
            right: 14px;
        }
    `}

    ${media.md`
        bottom: 48px;
        width: 56px;
        height: 56px;
        right: 90px;
        
        & svg {
            position: absolute;
            top: 12px;
            right: 14px;
        }
    `}

  ${media.lg`
        bottom: 48px;
        width: 56px;
        height: 56px;
        right: calc((100vw - 1344px + 136px) / 2);
        
        & svg {
            position: absolute;
            top: 12px;
            right: 14px;
        }
    `}
`;